import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43ac7ece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"80vw"} }
const _hoisted_2 = { class: "main-layout" }
const _hoisted_3 = { class: "container flex col g10" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "flex grow align-center" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex grow justify-between align-center" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = ["onPress"]
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = { class: "flex col" }
const _hoisted_13 = { class: "flex col" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "panel flex grow justify-between align center" }
const _hoisted_16 = { class: "flex align-center" }
const _hoisted_17 = { class: "subtitle" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted f12" }, "minutes", -1))
const _hoisted_19 = { class: "panel flex grow justify-between align center" }
const _hoisted_20 = { class: "subtitle" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "panel flex align-center justify-between grow" }
const _hoisted_23 = { class: "subtitle" }
const _hoisted_24 = { class: "panel flex align-center justify-between grow" }
const _hoisted_25 = { class: "subtitle" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = { class: "panel flex align-center justify-between grow" }
const _hoisted_28 = {
  key: 0,
  class: "flex align-center justify-between"
}
const _hoisted_29 = { class: "subtitle" }
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_33 = {
  key: 0,
  class: "panel flex align-center justify-between grow"
}
const _hoisted_34 = { class: "flex align-center" }
const _hoisted_35 = { class: "flex g0 col align-start" }
const _hoisted_36 = { class: "bold" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted bold f12" }, "Etablissement propriétaire", -1))
const _hoisted_38 = { class: "flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BatteryChart = _resolveComponent("BatteryChart")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeCalendarRanged = _resolveComponent("SeCalendarRanged")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_ProbeChart = _resolveComponent("ProbeChart")!
  const _component_SeNumberPicker = _resolveComponent("SeNumberPicker")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "batteryModal",
      title: "Niveau de batterie"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_BatteryChart, {
            probe: _ctx.state.probe,
            ref: "batteryChart"
          }, null, 8, ["probe"])
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        subtitle: _ctx.state.probe!.probeUID,
        title: _ctx.state.probe!.name
      }, null, 8, ["subtitle", "title"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SeInput, {
              class: "grow",
              modelValue: _ctx.state.probe!.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.probe!.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ToggleSwitch, {
              modelValue: _ctx.state.probe!.active,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.probe!.active) = $event)),
              auto: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_SeButton, {
              tooltip: _ctx.Lang.getI18N('save'),
              onPress: _ctx.updateProbe,
              ref: "modifyBtn",
              icon: "/ico/save.svg"
            }, null, 8, ["tooltip", "onPress"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SeCalendarRanged, { ref: "calendar" }, null, 512),
            _createVNode(_component_SeButton, { onPress: _ctx.applyGraph }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("apply")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          (_ctx.state.probe?.batteryLevel != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onPress: _ctx.openBatteryModal,
                class: "battery-level-container flex align-center"
              }, [
                _createVNode(_component_SeImage, { src: "/ico/battery_medium.svg" }),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.state.probe?.batteryLevel) + "%", 1)
                ])
              ], 40, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ProbeChart, {
          ref: "graph",
          probe: _ctx.state.probe
        }, null, 8, ["probe"]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.Lang.getI18N("probe.upload_frequency")), 1),
                  _hoisted_18
                ]),
                _createVNode(_component_SeNumberPicker, {
                  modelValue: _ctx.state.postingIntervalMinutes,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.postingIntervalMinutes) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.Lang.getI18N("probe.send_push_notification")), 1),
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.state.probe!.pushNotification,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.probe!.pushNotification) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.Lang.getI18N("minimum-temperature")), 1),
              _createVNode(_component_SeNumberPicker, {
                modelValue: _ctx.state.probe!.minimumTemperature,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.probe!.minimumTemperature) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.Lang.getI18N("maximum-temperature")), 1),
              _createVNode(_component_SeNumberPicker, {
                modelValue: _ctx.state.probe!.maximumTemperature,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.probe!.maximumTemperature) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_ctx.state.probe!.isProbeWorking())
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.Lang.getI18N("probe.last_temperature")), 1),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.state.probe!.getProbeLastTimestamp()), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.state.probe!.getProbeLastTemperature()), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, "Aucune donnée"))
            ])
          ]),
          (_ctx.storeOwner != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_SeImage, { src: "ico/store.svg" }),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.storeOwner.name), 1),
                    _hoisted_37
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_SeFadeButton, {
                    style: {"color":"#f55454"},
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeOwnership())),
                    icon: "ico/trash.svg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Supprimer ")
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}